export default __webpack_public_path__ + "static/media/fb.bcca1540.svg";